export default __webpack_public_path__ + "static/media/clinica_nuestra.4a247979.png";